import { put, takeEvery, select } from "redux-saga/effects";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as actionTypes from "./constants";
import { appConfig } from "../../config";
import { push } from "connected-react-router";
import * as selectors from "../../service/selectors";
var btoa = require("Base64").btoa;

function* fetchCountry(action) {
  try {
    const token = localStorage.getItem("token");
    let res = yield fetch(appConfig.ip + "/countryCrncy", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      let resJSON = yield res.json();
      console.log("--------resJSON", resJSON);
      yield put({
        type: actionTypes.FETCH_PROFILECOUNTRY_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    yield put({
      type: actionTypes.FETCH_PROFILECOUNTRY_FAIL_ACTION,
      error: err,
    });
  }
}
function* fetchregion(params) {
  // let countryId = (params.params && params.params.countryId) || "";
  console.log("params===========", params);
  let countryId = params.params.countryId;
  console.log("countryId======countryId=====", countryId);
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/region?countryId=${countryId}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      let resJSON = yield res.json();
      yield put({
        type: actionTypes.FETCH_REGION_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    yield put({
      type: actionTypes.FETCH_REGION_FAIL_ACTION,
      error: err,
    });
  }
}

function* fetchlocation(params) {
  let regionId = (params.params && params.params.regionId) || null;
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(
      `${appConfig.ip}/operatingLoc?regionId=${regionId}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      let resJSON = yield res.json();
      yield put({
        type: actionTypes.FETCH_LOCATION_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    yield put({
      type: actionTypes.FETCH_LOCATION_FAIL_ACTION,
      error: err,
    });
  }
}

function* addshipperprofile(value) {
  console.log("hello add profile");
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));
  const cntryCrncyList = yield select(selectors.cntryCrncyList);
  const shiperData = {
    userId: user.id,
    name: value.value.name,
    lName: value.value.LName,
    crExpDate: value.value.crExpDate || "",
    addr: value.value.addr,
    callingCode: value.value.callingCode,
    city: value.value.city,
    cntry: value.value.cntry,
    crNumber: value.value.crNumber || "",
    region: value.value.region,
    location: value.value.location,
    crncyCode: value.value.currencyCode,
    zip: value.value.zip,
    glCode: value.value.glCode,
    hqAddr: value.value.hqAddr,
    hqEmail: value.value.hqEmail,
    hqFax: value.value.hqFax,
    hqPhn: value.value.hqPhn,
    landmark: value.value.landmark,
    mobileNo: value.value.mobileNo,
    orgName: value.value.orgName,
    spocDsgntn: value.value.spocDsgntn,
    spocEmail: value.value.spocEmail,
    spocName: value.value.spocName,
    spocPhn: value.value.spocPhn,
    // eslint-disable-next-line no-dupe-keys
    // crncyCode:value.value.curncyCode,
    ftLogin: false,
  };
  let imageData = {
    file: value.value && value.value.file,
  };

  console.log("==========", shiperData);

  try {
    const res = yield fetch(`${appConfig.ip}/shipperProf`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(shiperData),
    });

    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      let data = cntryCrncyList.filter(
        (data) =>
          data.countryId.id === resJSON.user.country &&
          data.currencyId.id === resJSON.user.curncyCode
      );
      localStorage.setItem(
        "user",
        JSON.stringify({
          ...resJSON.user,
          id: resJSON.user._id,
          cntry: data[0].countryId.name,
          currency: data[0].currencyId.iso4217Code,
        })
      );
      yield put({
        type: actionTypes.ADD_SHIPPERPROFILE_SUCCESS_ACTION,
      });

      yield put({
        type: "ADD_SHIPPER_IMG_INIT_ACTION",
        value: imageData,
        userId: user.id,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.ADD_SHIPPERPROFILE_FAIL_ACTION,
        error: err,
      });
    }
  }
}

function* addshipperImg(value) {
  let user = JSON.parse(localStorage.getItem("user"));
  if (value.value.file !== "") {
    try {
      const data = new FormData();

      data.append(value.userId, value.value.file, value.value.file.name);

      const token = localStorage.getItem("token");
      const res = yield fetch(`${appConfig.ip}/users/image`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: data,
      });
      if (!res.ok) {
        throw res;
      } else {
        const resJSON = yield res.json();
        console.log(resJSON);
        localStorage.setItem(
          "user",
          JSON.stringify({
            ...user,
            picture: resJSON.picture,
          })
        );

        yield put({
          type: actionTypes.ADD_SHIPPER_IMG_INIT_ACTION_SUCCESS_ACTION,
        });
        yield put(push("/dashboard"));

        yield toast.success("Shipper profile added successfully", {
          autoClose: 3000,
          className: "toastClass",
        });
      }
    } catch (err) {
      yield toast.error("Shipper profile image was not added", {
        autoClose: 3000,
        className: "toastClass",
      });
      if (err.ok === false) {
        yield put({
          type: actionTypes.ADD_SHIPPER_IMG_INIT_FAIL_ACTION,
          error: err,
        });
      } else {
      }
    }
  } else {
    yield put(push("/dashboard"));

    yield toast.success("Shipper profile added successfully", {
      autoClose: 3000,
      className: "toastClass",
    });
  }
}

export function* ProfileupdateActionWatcher() {
  yield takeEvery(actionTypes.FETCH_PROFILECOUNTRY_ACTION, fetchCountry);
  yield takeEvery(actionTypes.FETCH_REGION_ACTION, fetchregion);
  yield takeEvery(actionTypes.FETCH_LOCATION_ACTION, fetchlocation);
  yield takeEvery(actionTypes.ADD_SHIPPERPROFILE_ACTION, addshipperprofile);
  yield takeEvery(actionTypes.ADD_SHIPPER_IMG_INIT_ACTION, addshipperImg);
}
